import React from 'react';
import { Link } from 'react-router-dom';
import './Events.css';

const Events = () => {
  // External redirect handler
  const handleExternalRedirect = (url) => {
    window.open(url, '_blank'); // Opens in new tab
    // OR window.location.href = url; // Opens in same tab
  };

  return (
    <div className="events-page">
      <div className="events-hero">
        <h1>AICIS Events</h1>
        <p>Explore our past, present, and future summits</p>
      </div>

      <div className="events-grid">
        {/* Event Card 1 - Redirects to External Site */}
        <div className="event-card">
          <div className="event-card-badge">2025</div>
          <h2>AICIS 2025 Post Summit Workshop</h2>
          <p className="event-description">
            Review the outcomes and highlights from the 2025 Post Summit Workshop.
          </p>
          <div className="event-meta">
            <span>📅 August 2025</span>
            <span>📍 Abuja, Nigeria</span>
          </div>
          <button 
            onClick={() => handleExternalRedirect('https://aicisnigeria.abvig.org/')}
            className="event-btn external"
          >
            Visit Workshop Page →
          </button>
        </div>

        {/* Event Card 2 - Internal Page */}
        <div className="event-card">
          <div className="event-card-badge">2026</div>
          <h2>2026 Pre Summit Round Table</h2>
          <p className="event-description">
            High-level diplomatic and inter-ministerial stakeholder engagement workshop.
          </p>
          <div className="event-meta">
            <span>📅 14 May 2026</span>
            <span>📍 Ministry of Foreign Affairs, Abuja</span>
          </div>
          <Link to="/events/pre-summit" className="event-btn internal">
            View Details →
          </Link>
        </div>

        {/* Event Card 3 - Internal Page */}
        <div className="event-card featured">
          <div className="event-card-badge">2026</div>
          <h2>2026 Global Summit</h2>
          <p className="event-description">
            Africa Infrastructure, Climate Change, Security & Green Investment Summit.
          </p>
          <div className="event-meta">
            <span>📅 25-28 November 2026</span>
            <span>📍 Abuja, Nigeria</span>
          </div>
          <Link to="/events/global-summit" className="event-btn internal">
            View Details →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Events;